import { JsonObject, JsonProperty } from "json2typescript";
import { CaseLite } from "./cases/caseLite";
import { CaseSearchResults, CaseSearchResultsLite } from "./cases/caseSearchResults";
import { ClientLite } from "./clients/client";
import { ClientLiteSearchResults } from "./clients/clientSearchResults";
import { Event } from "./events/event";
import { CaseSession } from "./hearings/caseSession";
import { CaseSessionSearchResults } from "./hearings/hearingSearchResults";

@JsonObject('DashboardCount')
export class DashboardCount {

    @JsonProperty('clients', Number, true)
    clients: number = undefined;

    @JsonProperty('rejected_clients', Number, true)
    rejectedClients: number = undefined;

    @JsonProperty('new_cases', Number, true)
    newCases: number = undefined;

    @JsonProperty('pending_cases', Number, true)
    pendingCases: number = undefined;

    @JsonProperty('rejected_cases', Number, true)
    rejectedCases: number = undefined;

    @JsonProperty('court_hearings', Number, true)
    court: number = undefined;

    @JsonProperty('expert', Number, true)
    expert: number = undefined;

    @JsonProperty('deadlines', Number, true)
    deadlines: number = undefined;

    @JsonProperty('timesheet', Number, true)
    timesheet: number = undefined;

    @JsonProperty('invoices', Number, true)
    invoices: number = undefined;
}


@JsonObject('DashboardData')
export class DashboardData {
    @JsonProperty('count', DashboardCount, true)
    count: DashboardCount = null;

    @JsonProperty('new_clients', ClientLiteSearchResults, true)
    clients: ClientLiteSearchResults = null;

    @JsonProperty('new_files', [CaseLite], true)
    newCases: CaseLite[] = [];

    @JsonProperty('closed_files', [CaseLite], true)
    closedCases: CaseLite[] = [];

    @JsonProperty('court_hearings', CaseSessionSearchResults, true)
    courtHearings: CaseSessionSearchResults = null;

    @JsonProperty('rejected_cases', CaseSearchResultsLite, true)
    rejectedCases: CaseSearchResultsLite = null;

    @JsonProperty('deadlines', CaseSessionSearchResults, true)
    deadlines: CaseSessionSearchResults = null;

    @JsonProperty('events', [Event], true)
    events: Event[] = [];

    @JsonProperty('reminders', [Event], true)
    reminders: Event[] = [];
}

